import React from "react";
import PropTypes from "prop-types";

const MoreText = ({ isPaid }) => {
  if (isPaid) {
    return <span>View features</span>;
  }
  return <span>View free features</span>;
};

const PlanCardBenefitsButton = ({ isPaid, expanded, onToggle }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="plan-card-benefits-container"
    >
      <div className="dropdown-container">
        <div className="content">
          <div className="button-wrapper">
            {expanded ? (
              <div className="button-text">View less</div>
            ) : (
              <div className="button-text">
                <MoreText isPaid={isPaid} />
              </div>
            )}
          </div>
        </div>
        <div className="arrow">
          <i
            className={`lc-icon lc-icon-${expanded ? "up" : "down"} lc-icon-xs`}
          />
        </div>
      </div>
    </button>
  );
};

PlanCardBenefitsButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  isPaid: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default PlanCardBenefitsButton;
